<script>
  import DialogAllocation from '@components/Dialog/allocation'
  import createDownloadLink from "@utils/create-download-link";
  // import PDFObject from "pdfobject"
  export default {
    components: {
      DialogAllocation,
    },
    props: {
      investorStock: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        stockList: [
          {
            icon: 'icon-1',
            value: this.investorStock['announce-link'] ?? '',
            title: '重大訊息公告',
            alias: 'announcement'
          },
          {
            icon: 'icon-2',
            value: this.investorStock.dividend ?? [],
            title: '歷年股利分派',
            alias: 'allocation'
          },
          {
            icon: 'icon-3',
            value: this.investorStock['market-link'] ?? '',
            title: '即時股價',
            alias: 'stock'
          },
          {
            icon: 'icon-6',
            value: this.investorStock['shareholder-file'][0] ?? '',
            title: '主要股東名單',
            alias: 'mainList'
          }
        ],
        isDialogAllocationVisible: false,
        filedoading: false,
      }
    },
    methods: {
      openAllocationDialog() {
        this.isDialogAllocationVisible = true;
      },
      async handleClickItem(file) {
        this.filedoading = true;
        // const isPdf = file.contentType === 'application/pdf';
        // const isSupportPdf = PDFObject.supportsPDFs;
        // if(isPdf && isSupportPdf) {
        //   const routeItem = this.$router.resolve({
        //     name: 'media',
        //     params: {
        //       mediaUuid: file.uuid
        //     }
        //   });

        //   window.open(routeItem.href, '_blank');
        // } else {
          const response = await this.$store.dispatch('global/fetchFile', {
            url: file.downloadLink,
            responseType: 'blob'
          });

          createDownloadLink(file.title||file.name, response)
        // }
        this.filedoading = false
      }
    }
    // getFileType(fileName) {
    //   if(fileName !== null && fileName !== undefined) {
    //     const extIndex = fileName.lastIndexOf('.');
    //     if (extIndex !== -1) {
    //       const type = fileName.substr(extIndex + 1, fileName.length);
    //       if(type === 'pdf'){
    //         return 'pdf'
    //       }else {
    //         return false
    //       }
    //     }else{
    //       return false
    //     }
    //   }
    // },
  }
</script>
<template>
  <div :class="$style.sectionStock">
    <!-- 股東項目 -->
    <section class="container section sectionStock">
      <BaseSectionTitle title="股東項目" class="text-center"/>
      <div class="row sectionStock__list mobileGutter">
        <template v-for="(item,$index) in stockList">
          <div 
            v-if="!!item.value"
            :key="$index"
            class="col-6 sectionStock__item"
          >
            <template v-if="item.alias === 'allocation'">
              <a class="box " href="javascript:;" @click="openAllocationDialog">
                <div class="boxInner">
                  <div class="icon color-primary">
                    <img :src="require(`@src/assets/images/investor/sharehoders/${item.icon}.svg`)" alt="">
                  </div>
                  <p class="title mb-0 mt-1 text-gray-7"> {{ item.title }} </p>
                </div>
              </a>
            </template>
            <template v-else-if="item.alias === 'mainList' && !!item.value">
              <a  v-loading="filedoading" class="box" href="javascript:;"  @click="handleClickItem(item.value)">
                <div class="boxInner">
                  <div class="icon color-primary">
                    <img :src="require(`@src/assets/images/investor/sharehoders/${item.icon}.svg`)" alt="">
                  </div>
                  <p class="title mb-0 mt-1 text-gray-7"> {{ item.title }} </p>
                </div>
              </a>
            </template>
            <template v-else>
              <a class="box" :href="item.value" target="_blank">
                <div class="boxInner">
                  <div class="icon color-primary">
                    <img :src="require(`@src/assets/images/investor/sharehoders/${item.icon}.svg`)" alt="">
                  </div>
                  <p class="title mb-0 mt-1 text-gray-7"> {{ item.title }} </p>
                </div>
              </a>
            </template>
          </div>
        </template>
      </div>
    </section>
    <!--文件項目 -->
    <DialogAllocation
      :visible.sync="isDialogAllocationVisible"
      :list="investorStock.dividend"
    />
  </div>
</template>
<style lang="scss" module>
  .sectionStock {
    :global {
      .sectionStock {
        &__list {
          margin-top: -40px;
        }

        &__item {
          margin-top: 40px;

          .box {
            position: relative;
            display: flex;
            display: block;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding-top: 35%;
            cursor: pointer;
            background: #FFF;
            border: 1px solid $color-gray-3;
            border-radius: 2px;
            transition: .3s;

            @include max-lg {
              padding-top: 60%;
            }

            .boxInner {
              position: absolute;
              top: 50%;
              left: 50%;
              width: 100%;
              text-align: center;
              text-indent: 0.25em;
              transform: translate(-50%, -50%);
            }

            .icon {
              font-size: 4rem;
              transition: .3s;

              @include max-md {
                font-size: 2rem;
                img {
                  height: 40px;
                }
              }
            }

            .title {
              // margin-top: 24px;
              transition: .3s;
              // @include max-sm {
              //   font-size: 14px;
              // }

              // @include max-2sm {
              //   font-size: 12px;
              // }
              @include max-md {
                font-size: 0.875rem;
              }
            }

            &:hover {
              color: $color-primary-hover;
              border: 1px solid $color-primary-hover;

              .title {
                color: $color-primary-hover;
              }

              .icon {
                color: $color-primary-hover;
              }
            }
          }
        }
      }
    }
  }
</style>
